// extracted by mini-css-extract-plugin
export default {"changeLogWrapper":"useVersionChecker_changeLogWrapper__IAwf0","changeLog":"useVersionChecker_changeLog__iXQwe"};